import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao"

export default [
    {
    path: "/cursoregistro",
    name: "Curso Registro",
    component: () => import("../../view/Curso/Curso-Registro"),
    meta: {
        titulo: "Curso Registro",
        caminho: "cursoregistro",
        tipoPermissao: _permissao.GERENCIAR,
        breadcrumb: [
        { text: "Cursos", disabled: true, to: "/" },
      ],
    },
  },
  {
    path: "/cursoregistro/:id",
    name: "Alterar Curso Registro",
    props: true,
    component: () => import("../../view/Curso/Curso-Registro"),
    meta: {
        titulo: "Alterar Curso Registro",
        caminho: "cursoregistro",
        tipoPermissao: _permissao.GERENCIAR,
        breadcrumb: [
        { text: "Cursos", disabled: true, to: "/" },
      ],
    },
  },
  {
    path: "/cursoconsulta",
    name: "Consulta Curso",
    props: true,
    component: () => import("../../view/Curso/Curso-Consulta.vue"),
    meta: {
        titulo: "Consulta Curso Registro",
        caminho: "cursoconsulta",
        tipoPermissao: _permissao.LISTAR,
        breadcrumb: [
        { text: "Cursos", disabled: true, to: "/" },
      ],
    },
  },

]